"use strict";

var _toConsumableArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var add_button_module_scss_1 = __importDefault(require("./add-button.module.scss"));

var clsx_1 = __importDefault(require("clsx"));

var core_1 = require("@material-ui/core");

var Add_1 = __importDefault(require("@material-ui/icons/Add"));

var AddButton = function AddButton(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text,
      children = _ref.children,
      _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? [] : _ref$classNames,
      hideIcon = _ref.hideIcon,
      ref = _ref.ref;
  return react_1.default.createElement(core_1.Button, {
    ref: ref,
    className: clsx_1.default.apply(clsx_1, [add_button_module_scss_1.default.button].concat(_toConsumableArray(classNames))),
    variant: "outlined",
    color: "primary",
    onClick: onClick,
    "data-meta": "add-button"
  }, !hideIcon && react_1.default.createElement(Add_1.default, null), children ? children : text);
};

exports.default = AddButton;